import { cn } from '@rematter/ui-web';

type TemplateTypeCardProps = {
  label: string;
  sublabel?: string;
  isSelected: boolean;
  onClick: () => void;
};

export const TemplateTypeCard = ({
  label,
  sublabel,
  isSelected,
  onClick,
}: TemplateTypeCardProps) => (
  <div
    className={cn(
      '@TemplateTypeCard cursor-pointer rounded-md border-2 border-transparent p-2 text-sm transition-colors',
      isSelected && 'border-primary',
      !isSelected && 'hover:bg-neutral/5',
    )}
    onClick={onClick}
  >
    <div className="font-medium">{label}</div>
    <div
      className={cn(
        'truncate text-xs',
        sublabel && 'text-foreground/70',
        !sublabel && 'text-foreground/50',
      )}
    >
      {sublabel ?? 'No template'}
    </div>
  </div>
);
